import React from "react";
import ReactDOM from 'react-dom/client';
import "./config";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Navigation,
  Footer,
  Home,
  Learn,
  Contact,
  Testimonials,
  Schedule,
  NotFound
} from "./components";

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container); // Create a root

root.render(
  <Router>
    <Navigation />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/learn" element={<Learn />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <Footer />
  </Router>,

  document.getElementById("root")
);

serviceWorker.unregister();
